import { Box, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  ICandidate,
  ICommunicationLog,
  getCallLogsBasedOnPhoneNumber,
  validatePhoneNumber,
  amplitude,
} from 'wisestep-api';
import { ICandidateAggregatedData } from 'wisestep-base';

import NoDataFoundCard from '../../../components/noDataFoundCard';

import CallLogCard from './CallLogCard';

interface ICandidateCallLog {
  candidate: ICandidate | null;
  aggregation?: ICandidateAggregatedData;
  amplitudeEventHandler?: (eventName: string) => void;
}

const CandidateCallLogs = ({
  candidate,
  aggregation,
  amplitudeEventHandler = () => {},
}: ICandidateCallLog) => {
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState<string | null>(null);
  const [phoneNumbers, setPhoneNumbers] = useState<string[]>([]);
  const [callLogEntry, setcallLogEntry] = useState<ICommunicationLog[]>([]);

  useEffect(() => {
    const primaryPhoneNumber = aggregation?.candidateEntity?.phoneNumber || candidate?.phoneNumber;
    let alternatePhoneNumbers = aggregation?.candidateEntity?.alternatePhoneNumbers || [];
    const initialSelectedNumber = primaryPhoneNumber || alternatePhoneNumbers[0] || null;
    alternatePhoneNumbers = primaryPhoneNumber
      ? [primaryPhoneNumber, ...alternatePhoneNumbers]
      : [...alternatePhoneNumbers];
    setPhoneNumbers([...alternatePhoneNumbers]);
    setSelectedPhoneNumber(initialSelectedNumber);
  }, [aggregation, candidate]);

  useEffect(() => {
    const fetchData = async () => {
      if (candidate && selectedPhoneNumber !== null) {
        const cleanedPhoneNumber = selectedPhoneNumber.replace(/[\s()-]/g, '');
        const phoneNumberData = validatePhoneNumber(cleanedPhoneNumber, candidate?.currentLocation);

        const response = await getCallLogsBasedOnPhoneNumber(phoneNumberData.number, 1);

        if (response.data && response.data.length) {
          setcallLogEntry(response.data);
        }
      }
    };

    fetchData();
    amplitude('CandidateView_Communication_CallLogs', {
      clickedOn: 'Communication Logs Calls',
      pageName: 'candidate-layout',
      pageUrl: window.location.href,
    });
    amplitudeEventHandler('Communication Logs Calls');
  }, [candidate, selectedPhoneNumber]);

  const handlePhoneNumberChange = (phoneNumber) => {
    setSelectedPhoneNumber(phoneNumber);
  };

  return (
    <>
      {phoneNumbers.length > 0 ? (
        <>
          <Select
            labelId="phone-number-label"
            id="phone-number-select"
            value={selectedPhoneNumber || ''}
            sx={{ float: 'right', mb: '1rem' }}
            onChange={(e) => handlePhoneNumberChange(e.target.value)}
          >
            {phoneNumbers.map((number) => (
              <MenuItem key={number} value={number}>
                {number}
              </MenuItem>
            ))}
          </Select>

          {selectedPhoneNumber ? (
            <>
              {callLogEntry.length > 0 ? (
                <Box textAlign="center" mt={10}>
                  {callLogEntry.map((callLog, index) => (
                    <CallLogCard key={index} callLog={callLog} />
                  ))}
                </Box>
              ) : (
                <NoDataFoundCard text="No Calls found with this number" />
              )}
            </>
          ) : (
            <NoDataFoundCard text="Please select a phone number" />
          )}
        </>
      ) : (
        <NoDataFoundCard text="Candidate has no phone number linked to it" />
      )}
    </>
  );
};

export default CandidateCallLogs;
